import { Button, styled } from "@mui/material";
import { useState } from "react";
import BSInput from "./BSInput";
import BSSelect from "./BSSelect";
import CustomRangeFilter from "./CustomRangeFilter";

const StyledWrapper = styled("div")({
    display: "flex",
    gap: 8,
    alignItems: "center",
    flexWrap: "wrap",
    flexDirection: "row",
});

const CustomDataGridFilterToolbar = ({ fields, setFilter, setPage, onSubmit }) => {
    const [selectedField, setSelectedField] = useState(fields[0].field);
    const [value, setValue] = useState("");
    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);
    const [currencyFrom, setCurrencyFrom] = useState("");
    const [currencyTo, setCurrencyTo] = useState("");
    const [numberRangeFrom, setNumberRangeFrom] = useState("");
    const [numberRangeTo, setNumberRangeTo] = useState("");
    const label = fields.find((f) => f.field === selectedField)?.label ?? selectedField;
    const type = fields.find((f) => f.field === selectedField)?.type ?? null;

    const handleFieldChange = (field) => {
        setSelectedField(field);
        setValue("");
        setDateFrom(null);
        setDateTo(null);
        setCurrencyFrom("");
        setCurrencyTo("");
        setNumberRangeFrom("");
        setNumberRangeTo("");
    };

    const handleSearchSubmit = () => {
        const filter = {
            field: selectedField,
            type: type,
            ...(type === "date"
                ? { dateFrom, dateTo }
                : type === "currency"
                  ? { currencyFrom, currencyTo }
                  : type === "numberRange"
                    ? { numberRangeFrom, numberRangeTo }
                    : { value: value }),
        };
        setFilter(filter);
        setPage(1);
        onSubmit();
    };

    return (
        <StyledWrapper>
            {type !== "plaintext" ? (
                <CustomRangeFilter
                    type={type}
                    label={label}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    currencyFrom={currencyFrom}
                    currencyTo={currencyTo}
                    numberRangeFrom={numberRangeFrom}
                    numberRangeTo={numberRangeTo}
                    setDateFrom={setDateFrom}
                    setDateTo={setDateTo}
                    setCurrencyFrom={setCurrencyFrom}
                    setCurrencyTo={setCurrencyTo}
                    setNumberRangeFrom={setNumberRangeFrom}
                    setNumberRangeTo={setNumberRangeTo}
                />
            ) : (
                <BSInput
                    id="searchTermValue"
                    placeholder={`Search ${label}`}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" && handleSearchSubmit()}
                    extraFormControlStyles={{ marginBottom: "0px", minWidth: "325px", width: "auto" }}
                    extraInputStyles={{ marginTop: "0px" }}
                />
            )}
            <BSSelect
                id="searchTermField"
                value={selectedField}
                onChange={(e) => handleFieldChange(e.target.value)}
                options={fields.filter((f) => !f.hide).map((f) => ({ value: f.field, label: f.label }))}
                extraFormControlStyles={{ minWidth: "225px", marginBottom: "0px", marginTop: "0px", width: "auto" }}
                extraInputStyles={{ "--bsselect-input-mt": "0px" }}
            />
            {type && type !== "plaintext" && (
                <Button variant="contained" color="primary" onClick={handleSearchSubmit} style={{ width: "60px" }}>
                    Search
                </Button>
            )}
        </StyledWrapper>
    );
};

export default CustomDataGridFilterToolbar;
